import API from '@/services/http'
import { customTagUrl } from '@/services/url'

type ValidateTagInUse = {
  tagIds: string[]
}

export const validateTagInUse = (params: ValidateTagInUse) => API.admin.post<ValidateTagInUse>(customTagUrl.validateTagInUse, params)
